import { service as request } from '@/libs/request'

// 所有端均走 PHP 的同一套个人模型 API；浏览器只持有本次提交用的 Key。
export const getPersonalModelExamplesApi = () => request.post('user/api.PersonalModel/providerExamples', {})
export const verifyPersonalModelDraftApi = data => request.post('user/api.PersonalModel/verifyDraft', data)
export const savePersonalModelApi = data => request.post('user/api.PersonalModel/saveVerifiedModel', data)
export const rotatePersonalModelApi = data => request.post('user/api.PersonalModel/rotateCredential', data)
export const listPersonalModelsApi = () => request.post('user/api.PersonalModel/modelList', {})
export const disablePersonalModelApi = modelGuid => request.post('user/api.PersonalModel/disableModel', { modelGuid })
